<template>
  <treeselect
    v-if="venues && regions"
    ref="treeselect"
    v-model="internalValue"
    :disabled="deactivated"
    :multiple="multiple"
    :options="selectableVenues"
    :show-count="true"
    showCountOf="LEAF_DESCENDANTS"
    :placeholder="placeholder ? placeholder : multiple ? 'Select one or more venues' : 'Select a single venue'"
    :disable-branch-nodes="!multiple"
    :flatten-search-results="true"
    value-consists-of="LEAF_PRIORITY"
  >
    <!-- :value="treeValue"
    @input="onChange" -->
    <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
  </treeselect>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
// import styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: { Treeselect },
  props: {
    value: Object | Array,
    placeholder: String | undefined,
    globalMode: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    deactivated: {
      type: Boolean,
      default: false
    },
    filterCountries: {
      type: Array,
      default: null
    },
    filterRegions: {
      type: Array,
      default: null
    }
  },
  emits: ["venue"],
  methods: {
    getVenues(node) {
      if (!node.isBranch) return node.id; // Leaf id === venue id
      return node.children.flatMap(subnode => this.getVenues(subnode));
    }
  },
  computed: {
    ...mapGetters({
      regions: "regions/regions"
    }),
    venues() {
      return this.globalMode ? this.$store.getters["venues/globalVenues"] : this.$store.getters["venues/venues"];
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
        if (!this.multiple) {
          if (!v) return this.$emit("venue", null);
          const venue = this.venues.find(e => e.venueId === v);
          this.$emit("venue", {
            venueId: v,
            venueName: venue.name,
            shortName: venue.shortName,
            logoUrl: venue.logoUrl
          });
        }

        // if (!this.multiple) {
        //   this.$emit("input", v);
        // } else {
        //   const venues = v.flatMap(nodeId => {
        //     const node = this.$refs.treeselect.getNode(nodeId);
        //     return this.getVenues(node);
        //   });

        //   this.$emit("input", venues);
        // }
      }
    },
    selectableVenues() {
      const test = _.chain(this.venues)
        .filter(e => e.status === 0 || e.status === 2)
        .filter(e => e.country && e.country !== "")
        .filter(e => (this.filterCountries ? this.filterCountries.includes(e.country) : true))
        .filter(e => (this.filterRegions ? this.filterRegions.includes(e.regionId) : true))
        .groupBy(e => (e.country != "" ? e.country : "No country")) // Group by country
        .map((venues, country) => {
          const children = _.chain(venues)
            .groupBy(e => e.regionId) // Then group by region
            .map((regionVenues, regionId) => {
              const venues = regionVenues.map(venue => ({
                id: venue.venueId,
                label: venue.name
              }));

              const region = this.regions.find(e => e.id === regionId && e.countryName == country);
              if (region == null)
                return {
                  id: "noregion_" + country,
                  label: "No region",
                  children: venues
                };
              return {
                id: regionId,
                label: `${region.name} (${region.number})`,
                children: venues
              };
            })
            .groupBy(e => e.id) // eliminate multiple noregions
            .map(groups => {
              if (groups.length == 1) return groups[0];

              const mergedChildren = groups.reduce((acc, elem) => acc.concat(elem.children), []);
              return {
                id: groups[0].id,
                label: groups[0].label,
                children: mergedChildren
              };
            })
            .value();

          // Special case: Remove the No country -> No Region -> Venues nesting, and just use No country -> venues
          if (country == "No country")
            return {
              id: country,
              label: country,
              children: children[0].children
            };
          return { id: country, label: country, children: children };
        })
        .value();
      return test;
    }
  },
  async mounted() {
    await this.$store.dispatch("regions/getAll");
  }
};
</script>

<style lang="scss">
.vue-treeselect__multi-value {
  max-height: 180px;
  overflow-y: auto;
}
</style>